import makeStyles from '@mui/styles/makeStyles/makeStyles'
import { Theme } from '@mui/material'

interface NewReminderStyleProps {}

const useStyles = makeStyles<Theme, NewReminderStyleProps>(theme => ({
  root: {
    cursor: 'pointer',
    padding: 4
  },
  modalTitle: {
    marginBottom: '0px',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '20px',
    color: '#1F1F1F'
  },

  modalClose: {
    top: '16px',
    right: '12px'
  },
  dataRoot: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #C6C6C6',
    borderRadius: '4px',
    boxSizing: 'border-box',
    padding: 16,
    background: '#F5F6F8',
    marginTop: 16,
    transition: 'all 250ms',
    [theme.breakpoints.down('md')]: {
      flex: 1
    },
    '& div:first-child': {
      marginTop: 0
    }
  },
  sectionRoot: {
    display: 'flex',
    position: 'relative',
    boxSizing: 'border-box',
    marginTop: '16px',
    alignItems: 'center',
    borderBottom: '1px solid #C6C6C6',
    paddingBottom: '8px'
  },
  nonInputSectionRoot: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 16,
    gap: 12,
    alignItems: 'center'
  },
  input: {
    border: 'none',
    height: '31px',
    padding: '0',
    outline: 'none',
    background: 'transparent',
    fontSize: '14px',
    lineHeight: '17px',
    flex: 1,
    color: '#1F1F1F',
    resize: 'none',
    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },
  item: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '4px',
    marginRight: '4px',
    borderRadius: '100rem',
    border: `1px solid ${theme.palette.primary.main}`,
    background: theme.palette.secondary.main,
    color: theme.palette.primary.main,
    padding: '6px 10px',
    fontSize: '12px',
    lineHeight: '15px',
    userSelect: 'none',
    fontWeight: 700,
    cursor: 'pointer',

    '&:last-child': {
      marginRight: '0'
    }
  },
  dateSelector: {
    cursor: 'pointer'
  },
  btnSection: {
    justifyContent: 'space-between',
    display: 'flex',
    marginTop: 16
  },
  thunderIcon: {
    cursor: 'pointer',
    borderRadius: 4,
    border: `solid 1px #C6C6C6`,
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      padding: 4
    },
    '& :hover': {
      backgroundColor: 'lightgrey'
    }
  },
  optionList: {
    padding: 12,
    border: '1px solid #F0F0F0',
    boxShadow: '0px 20px 30px 2px rgba(0, 0, 0, 0.16)',
    borderRadius: '5px',
    width: 180,
    backgroundColor: 'white'
  },
  option: {
    borderRadius: '4px',
    padding: '10px',
    fontSize: '14px',
    lineHeight: '17px',
    color: '#3C425B',
    cursor: 'pointer',
    transition: 'all 200ms',

    '&:hover': {
      background: '#F5F6F8'
    }
  }
}))

export default useStyles
